import { NgModule } from "@angular/core";
import { AgGridModule } from "ag-grid-angular";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { AnvandareEditService } from "./anvandare-edit.service";
import { AnvandareListComponent } from "./anvandare-list/anvandare-list.component";
import { AnvandareComponent } from "./anvandare.component";
import { RedigeraAnvandareComponent } from "./redigera-anvandare/redigera-anvandare.component";
@NgModule({
    imports: [
        RaskCommonModule,
        AgGridModule,
        AnvandareComponent,
        RedigeraAnvandareComponent,
        AnvandareListComponent
    ],
    providers: [AnvandareEditService]
})
export class AnvandareModule { }
